module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/documents/documents.component.css
// module id = ./src/app/documents/documents.component.css
// module chunks = main